export const RESEND_EMAIL_TIMEOUT = 30 * 1000;
export const RESEND_TEAM_MEMBER_INVITATION_TIMEOUT = 30 * 1000;
